<template>
  <div>
    <label :class="{'input-required': required === true}">{{titulo}}</label>
    <mcx-multi-select
      v-model="selected"
      :options="options"
      :multiple="true"
      group-values="Empresas"
      group-label="Nome"
      :group-select="true"
      :show-labels="false"
      placeholder="Selecione"
      track-by="$id"
      :allow-empty="true"
      :preserve-search="true"
      :close-on-select="false"
      label="Nome"
      :isInvalid="isinvalidempresa"
    >
      <template slot="selection" slot-scope="select">
        <span class="multiselect__single" v-if="select.values.length == 1 && !select.isOpen">
          <div
            :key="item.Id"
            v-for="item in select.values"
            style="float: left"
            class="truncate"
          >{{ item.Nome}}</div>
        </span>
        <span
          class="multiselect__single"
          v-if="select.values.length > 1 && !select.isOpen"
        >{{ select.values.length }} Empresas selecionadas</span>
      </template>
      <template slot="beforeList">
        <label v-if="options.length > 0" class="label-selecionar-todas" @click='handleSelecionarTodas'>
          <span v-if="empresasSelecionadas.length > selected.length">Selecionar todas as empresas</span>
          <span v-if="empresasSelecionadas.length == selected.length">Remover todas as empresas</span>
        </label>
      </template>
      <span slot="noResult">Nenhum registro encontrado.</span>
      <span slot="noOptions">Selecione uma Empresa.</span>
    </mcx-multi-select>
    <div :class="{'invalid-feedback': true,'d-block': isinvalidempresa}">
      <span>Você deve selecionar uma empresa</span>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import Multiselect from "vue-multiselect";
import store from "../store";
var mcxMultiSelect = {
  extends: Multiselect,
  props: {
    isInvalid: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    isInvalid: function(val, oldValue) {
      this.$refs.tags.classList.remove("form-control");
      this.$refs.tags.classList.remove("is-invalid");

      if (val) {
        this.$refs.tags.classList.add("form-control");
        this.$refs.tags.classList.add("is-invalid");
      }
    }
  }
};

Vue.component("mcx-multi-select", mcxMultiSelect);

export default {
  name: "SelectEmpresas",
  props: ["model", "titulo", "required", "options", "isinvalidempresa"],
  data() {
    return {
      selected: []
    };
  },
  computed: {
    empresasSelecionadas () {
      let empresas = [];

      this.options.forEach(e => {
        e.Empresas.forEach(empresa => {
          empresas.push(empresa);
        });
      });

      return empresas;
    }
  },
  watch: {
    selected () {
      this.$emit("input", this.selected);
    },
    options () {
      const filtroPortaisEmpresas = store.getters.getFiltrosGlobais().FiltroPortaisEmpresas;
      
      if (filtroPortaisEmpresas) {
        const empresas = JSON.parse(filtroPortaisEmpresas).Empresas;
        
        this.selected = this.empresasSelecionadas.filter(empresa => 
          empresas.includes(empresa.Nome)
        );
      }
    }
  },

  methods: {
    handleSelecionarTodas () {
      if (this.empresasSelecionadas.length == this.selected.length)
        this.selected = [];
      else
        this.selected = this.empresasSelecionadas.slice(0);
    },
  }
};
</script>

<style scoped>
.truncate {
  width: 95%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.label-selecionar-todas {
  padding: 10px 20px; 
  cursor: pointer; 
  margin: 0px; 
  width: 100%
}

.label-selecionar-todas:hover {
  background-color: #5b2e90;
  color: white;
}
</style>